import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { FilterService } from '@progress/kendo-angular-grid';
import { Logger } from '@app/core';
import { CustomKendoFilter } from '@app/shared/kendo/custom-kendo-filter';

const log = new Logger('KendoCountrySelectComponent');

@Component({
  selector: 'app-kendo-country-select',
  templateUrl: './kendo-country-select.component.html',
  styleUrls: ['./kendo-country-select.component.scss'],
})
export class KendoCountrySelectComponent extends CustomKendoFilter implements OnInit, OnChanges {
  @Input() field = 'country_id';

  constructor(private formBuilder: FormBuilder, filterService: FilterService) {
    super(filterService);
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      country_id: [this.getObjectId(this.field)],
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    // Изчиства формата
    // Използва се, за да чисти филтрите, когато се сетне null state на таблицата
    if (this.form && changes && changes.filter && !changes.filter.currentValue) {
      this.form.reset();
    }
  }

  onSelect(event: any) {
    this.filter = this.removeFilter(this.field);

    const filters = [];
    if (event) {
      filters.push({
        field: this.field,
        operator: 'eq',
        value: event.id,
      });
    }

    const root = this.filter || {
      logic: 'and',
      filters: [],
    };

    if (filters.length) {
      root.filters.push(...filters);
    }
    this.filterService.filter(root);
    log.debug('filters', filters);
  }
}
